var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgI2(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    "aria-hidden": "true",
    xmlns: "http://www.w3.org/2000/svg",
    width: 190,
    height: 211,
    viewBox: "0 0 190 211",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_31",
    "data-name": "Group 31",
    transform: "translate(-451.5 -2001)"
  }, /*#__PURE__*/React.createElement("text", {
    id: "Calls_to_the_helpline_have_increased",
    "data-name": "Calls to the helpline have increased",
    transform: "translate(546.5 2025)",
    fill: "#1d1d1d",
    fontSize: 20,
    fontFamily: "Oswald-Medium, Oswald",
    fontWeight: 500
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -94.28,
    y: 0
  }, "CALLS TO THE HELPLINE "), /*#__PURE__*/React.createElement("tspan", {
    x: -66.11,
    y: 22
  }, "HAVE INCREASED")), /*#__PURE__*/React.createElement("text", {
    id: "_86_",
    "data-name": "86%",
    transform: "translate(546.5 2144)",
    fill: "#405968",
    fontSize: 100,
    fontFamily: "Oswald-Bold, Oswald",
    fontWeight: 700,
    letterSpacing: "-0.04em"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -85.55,
    y: 0
  }, "86"), /*#__PURE__*/React.createElement("tspan", {
    y: 0,
    fontFamily: "Oswald-Light, Oswald",
    fontWeight: 300
  }, "%")), /*#__PURE__*/React.createElement("text", {
    id: "during_the_pandemic_with_stay-at-home_measures_believed_to_be_a_factor",
    "data-name": "during the pandemic with stay-at-home measures believed to be a factor",
    transform: "translate(546.5 2169)",
    fill: "#1d1d1d",
    fontSize: 16,
    fontFamily: "Lato-Regular, Lato"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -91.464,
    y: 0
  }, "during the pandemic with "), /*#__PURE__*/React.createElement("tspan", {
    x: -82.064,
    y: 20
  }, "stay-at-home measures"), /*#__PURE__*/React.createElement("tspan", {
    x: -78.496,
    y: 40
  }, "believed to be a factor")))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgI2);
export default __webpack_public_path__ + "static/media/i2.2b100d009519624a5c64412a2ac3d540.svg";
export { ForwardRef as ReactComponent };